import { Root, json, rootLoader, useLoaderData, useLocation } from '@ubo/losse-sjedel';
import type { LinksFunction, LoaderFunction, RootProps } from '@ubo/losse-sjedel';
import PageNotFound from '~/components/layout/PageNotFound';
import { replaceWordpressUrl } from '~/utils/wordpressUrl.server';
import styles from '~/global.css';
import FlexContent from './graphql/FlexContent';
import Queries from './graphql/Queries';
import PostTypes from './graphql/PostTypes';

export const flexData = {
  flexContent: FlexContent,
  queries: Queries,
  postTypes: PostTypes
};

export const links: LinksFunction = () => {
  return [
  {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com'
  },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com'
  },
  {
    rel: 'stylesheet',
    href: 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;700;900&display=block'
  },
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: '/static/nprogress.min.css',
    rel: 'stylesheet',
    async: true
  },
  {
    rel: 'preload',
    as: 'style',
    href: styles
  },
  {
    href: styles,
    rel: 'stylesheet'
  },
  {
    href: '/manifest.json',
    rel: 'manifest'
  },
  {
    rel: 'icon',
    href: '/favicon.png',
    type: 'image/png'
  }];

};

export const loader: LoaderFunction = async (args) => {
  const response = (await rootLoader(args) as Response);

  return json(replaceWordpressUrl(await response.json(), args.request));
};

export function CatchBoundary() {
  return <PageNotFound />;
}

export default function App() {
  const data = useLoaderData<RootProps>();
  const location = useLocation();

  // @ts-ignore
  return <Root {...data} lang={location.pathname.includes('/en/') ? 'en' : 'nl'} />;
}